import { css } from "@emotion/react";

export const root = css`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  flex-grow: 1;
  min-width: 0;
`;
